const createHTMLElement = require("../dom/createHTMLElement");

/**
 * @return {HTMLElement}
 */
module.exports = function smsNotAvailableInYourCountry() {
    return createHTMLElement(`
        <div data-component="smsNotAvailableInYourCountry">
            <p>Iterable at Iterable is currently only sending SMS to the US. For the full list of countries available for your SMS program, reach out to your CSM or account rep</p>
        </div>
    `);
}
